<div class="timeline-wrapper">
  <div class="timeline-item">
    <div class="animated-background">
      <div *ngFor="let line of [1, 2, 3, 4, 5]" class="background-masker" [ngClass]="'line-'+ line"></div>
      <div *ngFor="let line of [1, 2, 3, 4, 5]" class="background-masker" [ngClass]="'line-end-'+ line"></div>
    </div>
  </div>
</div>
